import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { ChannelListActionsCell } from './channel-list-actions.cell';
import { ChannelListActionsHeader } from './channel-list-actions.header';

export const ChannelListActionsColumn: DisplayColumnDef<
  GatewayChannelWithChargePointInfoModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: ChannelListActionsHeader,
  cell: ChannelListActionsCell,
};
